import { useState, useRef } from "react";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const Form = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        honeypot: '',
        captcha: ''
    });
    const [isSending, setIsSending] = useState(false);
    const [countryCode, setCountryCode] = useState('+57');
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const [errors, setErrors] = useState({});
    const recaptchaRef = useRef(null);

    const handlePhoneChange = (phone, countryData) => {
        const formattedPhone = phone.startsWith('+') ? phone : `+${phone}`;
        handleChange({ target: { name: 'phone', value: formattedPhone } });
        setCountryCode(countryData.dialCode);

        const parsedPhone = parsePhoneNumberFromString(formattedPhone, countryData.countryCode.toUpperCase());

        setIsPhoneValid(parsedPhone && parsedPhone.isValid());
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        setErrors({
            ...errors,
            [e.target.name]: ''
        });
    };

    const handleCaptchaChange = (value) => {
        setFormData({
            ...formData,
            captcha: value,
        });

        if (value) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                captcha: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) {
            newErrors.name = "El nombre es obligatorio.";
        }
        if (!formData.email) {
            newErrors.email = "El correo es obligatorio.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "El correo no tiene un formato válido.";
        }
        const formattedCountryCode = countryCode.startsWith('+') ? countryCode : `+${countryCode}`;
        if (!formData.phone ||
            formData.phone === formattedCountryCode) {
            newErrors.phone = "El número de teléfono es obligatorio.";
        }
        else if (!isPhoneValid) {
            newErrors.phone = "El número de teléfono no es válido.";
        }
        if (!formData.message) {
            newErrors.message = "El mensaje es obligatorio.";
        }
        if (!formData.captcha) {
            newErrors.captcha = "Por favor, completa el CAPTCHA.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.honeypot) {
            alert("Formulario enviado por un bot.");
            return;
        }

        if (!validateForm()) {
            return;
        }

        setIsSending(true);
        const response = await fetch('http://localhost:5000/send-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        });
        setIsSending(false);

        if (response.ok) {
            setFormData({
                name: '',
                email: '',
                phone: countryCode,
                message: '',
                captcha: ''
            });
            setIsPhoneValid(false);
            recaptchaRef.current.reset();
            alert("Correo enviado correctamente");
        } else {
            alert("Hubo un error al enviar el correo");
        }
    };

    return [handlePhoneChange, handleSubmit, handleChange, formData, isSending,
        errors, handleCaptchaChange, recaptchaRef];
}

export default Form;
